import { useEffect, useRef, useState, forwardRef } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import styles from "./prospectlist.module.css";
import { Link } from "react-router-dom";
import { Checkbox, Typography } from "@material-ui/core";
import { ArrowRight, ChevronDown, Filter, Grid, Home, List, Plus, X } from "react-feather";
import Helmet from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/Loader";
import { TableLoader } from "../../components/LoaderC";
import Footer from "../../components/Footer";
import { Search, Calendar } from "react-feather";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { Button } from "react-bootstrap";
import { AddLogCallAPI } from "../../components/AddLogs";
import { FormControl, InputLabel, MenuItem, Select, Snackbar, Slide, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TablePagination, Menu, TextField } from "@mui/material";
import dayjs from "dayjs";
import DateRangePicker from "rsuite/DateRangePicker";
import IconButton from "@mui/material/IconButton";
import StepOneForm from "./Components/AddProspect/StepOneForm";
import StepTwoForm from "./Components/AddProspect/StepTwoForm";
import StepThreeForm from "./Components/AddProspect/StepThreeForm";
import PeoplePageTitle from "../tenants/components/PeoplePageTitle";
import { communicationChatReload } from "../../redux/actions/communicationChatRloadAction";
import { setConversationId } from "../../redux/actions/communicationConversationId";
import { communicationVoiceCallScreenOpen } from "../../redux/actions/communicationVoiceCallScreenAction";
import { setVoiceCallInfo } from "../../redux/actions/communicationVoiceCallInfo";
import NumberFormat from "react-number-format";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Controller, useForm } from "react-hook-form";
import AddToEmailGroup from "./Components/add-to-email-group/AddToEmailGroup";
import ProspectCard from "./Components/gridview/ProspectCard";
import withCustomAuthenticationRequired from "../../auth/withCustomAuthenticationRequired";

const CreditScoreField = forwardRef((props, ref) => {
  return (<NumberFormat customInput={TextField} prefix="" displayType="input" format={"###"} {...props} />);
});

const MoneyField = forwardRef((props, ref) => {
  return (<NumberFormat customInput={TextField} prefix="" displayType="input" type="text" thousandSeparator={true} allowNegative={false} decimalScale={0} {...props} />);
});

const schema1 = yup.object().shape({
  min: yup.string().required("This field is Required"),
  max: yup.string().required("This field is Required"),
});

const schema2 = yup.object().shape({
  min: yup.string().required("This field is Required"),
  max: yup.string().required("This field is Required"),
});

const ProspectList = ({ handleView, history, match }) => {
  const voiceCallInfo = useSelector((store) => store.communicationVoiceCallInfoReducer);
  const dispatch = useDispatch();
  const { getAccessTokenSilently, user, isAuthenticated } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(false);
  const [prospectList, setProspectList] = useState([]);
  const [prospectFilteredList, setFilteredProspectList] = useState([]);
  const [allProperties, setAllProperties] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [perPage, setPerPage] = useState(8);
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [isOpenEmailGroup, setIsOpenEmailGroup] = useState(false);
  const [selectedEmailGroup, setSelectedEmailGroup] = useState(null);
  const [isFirstTimeLoading, setIsFirstTimeLoading] = useState(true);
  const [selectedProspectForEmailGroup, setSelectedProspectForEmailGroup] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [filterData, setFilterData] = useState({ searchKey: "", created: null, property: "", prospect: ["applied", "not_applied", "screened", "approved", "declined"], credit: "", income: "", perPage: 8, page: 0 });
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(0);
  const [openAddProspectModal, setOpenAddProspectModal] = useState(false);
  const [addFormStep, setAddFormStep] = useState(1);
  const [stepOneData, setStepOneData] = useState(null);
  const [stepTwoData, setStepTwoData] = useState(null);
  const [filterOpen, setFilterOpen] = useState(false);
  const [archiveModalOpen, setArchiveModalOpen] = useState(false);
  const [archiveId, setArchiveId] = useState(0);
  const [isArchived, setIsArchived] = useState(0);
  const [applicationModalOpen, setApplicationModalOpen] = useState(false);
  const [openLeaderBoardModal, setOpenLeaderBoardModal] = useState(false);
  const [openCallModal, setOpenCallModal] = useState(false);
  const [prospectInfoObj, setProspectInfoObj] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [addCustomCredit, setAddCustomCredit] = useState(false);
  const [addCustomSalary, setAddCustomSalary] = useState(false);
  const [salaryFilterOpen, setSalaryFilterOpen] = useState(false);
  const [salaryFilterDefaultOpen, setSalaryFilterDefaultOpen] = useState(false);
  const [creditFilterOpen, setCreditFilterOpen] = useState(false);
  const [creditFilterDefaultOpen, setCreditFilterDefaultOpen] = useState(false);
  const timeoutRef = useRef(null);
  const [allCustomFilterList, setAllCustomFilterList] = useState([]);
  const [creditFilterList, setCreditFilterList] = useState([]);
  const [salaryFilterList, setSalaryFilterList] = useState([]);

  useEffect(() => {
    const fetchAllFilters = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      await axios.get(process.env.REACT_APP_APPLICANT_API_URL + "v1/prospectfilter", {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        setAllCustomFilterList(response.data.data);


      }).catch((error) => {
        if (typeof error.response !== "undefined")
          toast.error(error.response.data.message);
      });
    }

    fetchAllFilters();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    let creditFilterLIstTemp = allCustomFilterList?.filter(i => i?.type === 'credit')?.map(i => {
      return { value: i?.value, 'label': i?.text, is_custom: 1 };
    });

    let salaryFilterLIstTemp = allCustomFilterList?.filter(i => i?.type === 'salary')?.map(i => {
      return { value: i?.value, 'label': i?.text, is_custom: 1 };
    });

    setCreditFilterList(creditFilterLIstTemp);
    setSalaryFilterList(salaryFilterLIstTemp);
  }, [allCustomFilterList]);

  useEffect(() => {
    const fetchAllProperties = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      await axios.get(process.env.REACT_APP_APPLICANT_API_URL + "v1/get-all-properties", {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        let propertyData = response.data.data;
        propertyData = [{ value: "all", label: "Any" }].concat(propertyData);

        setAllProperties(propertyData);
      }).catch((error) => {
        if (typeof error.response !== "undefined")
          toast.error(error.response.data.message);
      });
    }

    fetchAllProperties();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    fetchProspectInChunk();
  }, [getAccessTokenSilently, filterData]);

  const fetchProspectInChunk = async () => {
    let { searchKey, created, property, prospect, credit, income, perPage, page } = filterData;

    if (created && Array.isArray(created) && created.length === 2) {
      const start = dayjs(created[0]).format("YYYY-MM-DD");
      const end = dayjs(created[1]).format("YYYY-MM-DD");
      created = `${start},${end}`;
    }

    const queryParams = new URLSearchParams();
    queryParams.append("page", page);
    queryParams.append("perPage", perPage);
    queryParams.append("searchKey", searchKey);
    queryParams.append("created", created); // if it's a range, you may need JSON.stringify
    queryParams.append("property", property);
    queryParams.append("prospect", prospect.join());
    queryParams.append("credit", credit);
    queryParams.append("income", income);

    if (isFirstTimeLoading) {
      setContentLoading(true);
      setIsFirstTimeLoading(false);
    }

    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    await axios.get(`${process.env.REACT_APP_APPLICANT_API_URL}v1/prospects-new?${queryParams.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setContentLoading(false);
      setFilteredProspectList(response.data.data);
      setTotalCount(response.data.total);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setContentLoading(false);
    });
  }

  useEffect(() => {
    const pageState = localStorage.getItem("prospectPageState");

    if (pageState) {
      const prospectLocalStorageState = JSON.parse(pageState);
      const savedFilters = prospectLocalStorageState?.filters || {};

      if (page === 0 && typeof prospectLocalStorageState.page === "number") {
        setPage(prospectLocalStorageState.page);
      }

      if (perPage === 8 && typeof prospectLocalStorageState.perPage === "number") {
        setPerPage(prospectLocalStorageState.perPage);
      }

      setFilterData((prev) => ({
        ...prev,
        page: prev.page || savedFilters.page || 0,
        perPage: prev.perPage || savedFilters.perPage || 8,
        searchKey: prev.searchKey || savedFilters.searchKey || "",
        property: prev.property || savedFilters.property || "",
        prospect: savedFilters.prospect || prev.prospect || [],
        credit: prev.credit || savedFilters.credit || "",
        income: prev.income || savedFilters.income || "",
        created: prev.created === null && savedFilters.created ? [savedFilters.created[0] ? new Date(savedFilters.created[0]) : null, savedFilters.created[1] ? new Date(savedFilters.created[1]) : null] : prev.created
      }));
    }
  }, []);

  useEffect(() => {
    return () => {
      const stateToSave = { filters: filterData, page, perPage };
      localStorage.setItem("prospectPageState", JSON.stringify(stateToSave));
    };
  }, [filterData, page, perPage]);

  useEffect(() => {
    const getGroupList = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios(process.env.REACT_APP_USER_API_URL + "v1/campaign/groups", {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        if (Array.isArray(response?.data?.data)) {
          const prospectGroups = response.data.data.filter((pg) => pg.type === "Prospect");
          setGroupList(prospectGroups);
        } else {
          setGroupList([]);
        }
      }).catch((error) => {
        if (typeof error.response !== "undefined")
          toast.error(error.response.data.message);
      });
    }

    if (isOpenEmailGroup && groupList.length === 0) {
      getGroupList();
    }
  }, [getAccessTokenSilently, isOpenEmailGroup]);

  const onChangeHandler = (e) => {
    const value = e.target.value;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setFilterData((prev) => ({ ...prev, searchKey: value, page: 0 }));
      setPage(0);
    }, 300);
  };

  const handleChangeFilter = (stype, selectedOption) => {
    let filterDataTemp = filterData;
    if (stype === "property") {
      filterDataTemp = { ...filterDataTemp, property: selectedOption?.target?.value };
    }
    if (stype === "prospect") {
      filterDataTemp = { ...filterDataTemp, prospect: selectedOption?.target?.value };
    }
    if (stype === "credit") {
      filterDataTemp = { ...filterDataTemp, credit: selectedOption?.target?.value };
    }
    if (stype === "income") {
      filterDataTemp = { ...filterDataTemp, income: selectedOption?.target?.value };
    }
    setFilterData(filterDataTemp);
    setPage(0);
  };

  const changeDateFilter = (date) => {
    let filterDataTemp = filterData;
    filterDataTemp = { ...filterDataTemp, created: date };
    setFilterData(filterDataTemp);
    setPage(0);
  };

  const deleteConfirm = async () => {
    let deleteIdTemp = deleteId;
    setOpenDeleteModal(false);
    setDeleteId(0);
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.delete(process.env.REACT_APP_APPLICANT_API_URL + "v1/prospects/" + deleteIdTemp, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);

      setSnackbarMsg(response.data.message);
      setSnackbarOpen(true);

      let respData = response.data.data;

      let prospectListTemp = prospectList;
      prospectListTemp = prospectListTemp.filter((i) => i.id !== deleteIdTemp);
      setProspectList(prospectListTemp);

      let logData = {
        title: "Prospect is deleted",
        description: [
          "Name: " + respData?.full_name,
          "Email: " + respData?.email,
          "Phone: " + respData?.phone,
          "Property: " + respData?.property_name,
          "Apartment: " + respData?.apt_no,
        ],
      };
      AddLogCallAPI(logData, token);

      dispatch(communicationChatReload(true));
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const onSubmitOne = (data) => {
    setAddFormStep(2);
    setStepOneData(data);
  };

  const onSubmitTwo = (data) => {
    let cData = {};
    if (typeof data.credit_score !== "undefined") {
      cData = { ...cData, credit_score: data.credit_score };
    }
    if (typeof data.have_pets !== "undefined") {
      cData = { ...cData, have_pets: data.have_pets };
    }
    if (typeof data.income_per_year !== "undefined") {
      cData = { ...cData, income_per_year: data.income_per_year };
    }
    if (typeof data.bedrooms !== "undefined") {
      cData = { ...cData, bedrooms: data.bedrooms };
    }
    if (typeof data.move_in_date !== "undefined") {
      cData = { ...cData, move_in_date: dayjs(data?.move_in_date).format("YYYY-MM-DD HH:mm:ss") };
    }
    if (typeof data.bathrooms !== "undefined") {
      cData = { ...cData, bathrooms: data.bathrooms };
    }
    if (typeof data.do_you_smoke !== "undefined") {
      cData = { ...cData, do_you_smoke: data.do_you_smoke };
    }
    if (typeof data.is_tour !== "undefined") {
      cData = { ...cData, is_tour: data.is_tour };
    }

    setAddFormStep(3);
    setStepTwoData(cData);
  };

  const onAddProspectSubmit = async (data) => {
    let postData = {};
    let is_tour = false;
    postData = { ...postData, ...stepOneData, ...stepTwoData };
    if (addFormStep === 2) {
      if (typeof data.credit_score !== "undefined") {
        postData = { ...postData, credit_score: data.credit_score };
      }
      if (typeof data.have_pets !== "undefined") {
        postData = { ...postData, have_pets: data.have_pets };
      }
      if (typeof data.income_per_year !== "undefined") {
        postData = { ...postData, income_per_year: data.income_per_year };
      }
      if (typeof data.bedrooms !== "undefined") {
        postData = { ...postData, bedrooms: data.bedrooms };
      }
      if (typeof data.move_in_date !== "undefined") {
        postData = { ...postData, move_in_date: dayjs(data?.move_in_date).format("YYYY-MM-DD HH:mm:ss") };
      }
      if (typeof data.bathrooms !== "undefined") {
        postData = { ...postData, bathrooms: data.bathrooms };
      }
      if (typeof data.do_you_smoke !== "undefined") {
        postData = { ...postData, do_you_smoke: data.do_you_smoke };
      }
    }

    if (typeof postData.is_tour !== "undefined") {
      is_tour = postData.is_tour;
    }

    if (typeof data.tour_date_time !== "undefined") {
      postData = { ...postData, tour_date_time: data.tour_date_time };
    }

    setOpenAddProspectModal(false);
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    await axios.post(process.env.REACT_APP_APPLICANT_API_URL + "v1/add-prospect", postData, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);

      setSnackbarMsg(response.data.message);
      setSnackbarOpen(true);
      dispatch(communicationChatReload(true));

      setFilterData(prev => {
        return { ...prev, page: 0 };
      })

      let logData = {
        title: "A new prospect is added",
        description: [
          "Name: " + response?.data?.data?.full_name,
          "Phone: " + response?.data?.data?.phone,
          "Property: " + response?.data?.data?.property_name,
          "Apartment: " + response?.data?.data?.apt_no,
        ],
      };
      AddLogCallAPI(logData, token);

      if (is_tour) {
        let logData = {
          title: "A new prospect tour is added",
          description: [
            "Name: " + response?.data?.data?.full_name,
            "Phone: " + response?.data?.data?.phone,
            "Property: " + response?.data?.data?.property_name,
            "Date/Time: " + dayjs(data.tour_date_time).format("MM/DD/YYYY hh:mm a"),
          ],
        };
        AddLogCallAPI(logData, token);
      }
    }).catch((error) => {
      setLoading(false);
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
    });
  };

  const FilterOpenFunction = () => {
    setFilterOpen(true);
  }

  const FilterCloseFunction = () => {
    setFilterOpen(false);
  }

  const openProspectConversation = (e, item) => {
    const { conversation_id } = item;
    e.preventDefault();
    dispatch(setConversationId(conversation_id));
  }

  const archiveConfirm = async () => {
    setArchiveModalOpen(false);
    setLoading(true);

    let URL = "";

    if (isArchived === 0) {
      URL = process.env.REACT_APP_APPLICANT_API_URL + "v1/prospect-archive/" + archiveId;
    } else {
      URL = process.env.REACT_APP_APPLICANT_API_URL + "v1/prospect-unarchive/" + archiveId;
    }

    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.put(URL, {}, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);

      setSnackbarMsg(response.data.message);
      setSnackbarOpen(true);

      let respData = response.data.data;

      setProspectList((prev) => {
        return prev.map((i) => {
          if (i.id === archiveId) {
            return { ...i, is_archived: isArchived ? 0 : 1 };
          }
          return i;
        });
      });

      dispatch(communicationChatReload(true));

      let logData = {
        title: "Prospect is " + (isArchived ? "unarchived" : "archived"),
        description: [
          "Name: " + respData?.full_name,
          "Email: " + respData?.email,
          "Phone: " + respData?.phone,
          "Property: " + respData?.property_name,
          "Apartment: " + respData?.apt_no,
        ],
      };
      AddLogCallAPI(logData, token);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const sendApplicationLInk = async () => {
    setApplicationModalOpen(false);
    setLoading(true);

    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.get(process.env.REACT_APP_APPLICANT_API_URL + "v1/send-application-link/" + archiveId, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);

      setSnackbarMsg(response.data.message);
      setSnackbarOpen(true);

      let respData = response.data.data;

      dispatch(communicationChatReload(true));

      let logData = {
        title: "Application link has been sent successfully.",
        description: [
          "Name: " + respData?.full_name,
          "Email: " + respData?.email,
          "Phone: " + respData?.phone,
          "Property: " + respData?.property_name,
          "Apartment: " + respData?.apt_no,
        ],
      };
      AddLogCallAPI(logData, token);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  };

  const addToLeaderBoard = async () => {
    setOpenLeaderBoardModal(false);
    setLoading(true);

    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.get(process.env.REACT_APP_APPLICANT_API_URL + "v1/add-to-leaderboard/" + archiveId, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);

      setSnackbarMsg(response.data.message);
      setSnackbarOpen(true);

      setProspectList((prev) => {
        return prev.map((i) => {
          if (i.id === archiveId) {
            return { ...i, is_leaderboard: 1, leaderboard_name: "Leader" };
          }
          return i;
        });
      });

      setArchiveId(0);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const initiateVoiceCall = (item) => {
    if (voiceCallInfo) {
      toast.error("You are on anotehr call.");
    } else {
      setOpenCallModal(true);
      setProspectInfoObj(item);
    }
  };
  const initiateVoiceCallConfirm = () => {
    setOpenCallModal(false);
    let newProspectInfo = {
      id: prospectInfoObj?.id,
      full_name: prospectInfoObj?.full_name,
      initial: prospectInfoObj?.initial,
      phone: prospectInfoObj?.phone,
      user_avatar: prospectInfoObj?.user_avatar,
      type: "Prospect"
    };
    dispatch(communicationVoiceCallScreenOpen(true));
    dispatch(setVoiceCallInfo(newProspectInfo));
  };

  const { handleSubmit: handleSubmit1, control: control1 } = useForm({
    resolver: yupResolver(schema1),
  });

  const { handleSubmit: handleSubmit2, control: control2 } = useForm({
    resolver: yupResolver(schema2),
  });

  const onSubmitCreditFiler = (data) => {
    setAddCustomCredit(false);
    setCreditFilterOpen(false);

    setFilterData(prev => {
      return { ...prev, credit: data?.min + ',' + data?.max };
    });

    axios.post(process.env.REACT_APP_APPLICANT_API_URL + "v1/prospectfilter", { value: data?.min + ',' + data?.max, text: data?.min + ' - ' + data?.max, type: 'credit' }).then((response) => {
      setAllCustomFilterList(prev => {
        return prev.concat(response.data.data);
      })
    }).catch((error) => { });
  };

  const onSubmitSalaryFiler = (data) => {
    setAddCustomSalary(false);
    setSalaryFilterOpen(false);

    setSalaryFilterList(prev => {
      return prev.concat({ value: parseInt(data.min.toString().replace(/,/g, ""), 10) + ',' + parseInt(data.max.toString().replace(/,/g, ""), 10), label: '$' + data?.min + ' - $' + data?.max, is_custom: 1 })
    });

    setFilterData(prev => {
      return { ...prev, income: parseInt(data.min.toString().replace(/,/g, ""), 10) + ',' + parseInt(data.max.toString().replace(/,/g, ""), 10) };
    });

    axios.post(process.env.REACT_APP_APPLICANT_API_URL + "v1/prospectfilter", { value: parseInt(data.min.toString().replace(/,/g, ""), 10) + ',' + parseInt(data.max.toString().replace(/,/g, ""), 10), text: '$' + data?.min + ' - $' + data?.max, type: 'salary' }).then((response) => {
      setAllCustomFilterList(prev => {
        return prev.concat(response.data.data);
      })
    }).catch((error) => { });

  };

  useEffect(() => {
    if (filterData?.credit === "custom" && creditFilterDefaultOpen) {
      setCreditFilterOpen(true);
    }
  }, [filterData?.credit, creditFilterDefaultOpen]);

  useEffect(() => {
    if (filterData?.income === "custom" && salaryFilterDefaultOpen) {
      setSalaryFilterOpen(true);
    }
  }, [filterData?.income, salaryFilterDefaultOpen]);

  const handleProspectToggle = (prospectId, prospectEmail) => {
    if (prospectEmail === "") {
      toast.error("No email available for this prospect. You'll need to add an email to this prospect.");
      return false;
    }

    setSelectedProspectForEmailGroup((prev) => prev.includes(prospectId) ? prev.filter((id) => id !== prospectId) : [...prev, prospectId]);
  };

  const handleAddToGroup = async () => {
    if (!selectedEmailGroup) {
      setSnackbarOpen(true);
      setSnackbarMsg("Please select email group!");
      return false;
    } else if (selectedProspectForEmailGroup.length === 0) {
      setSnackbarOpen(true);
      setSnackbarMsg("Please select prospect!");
      return false;
    }

    setLoading(true);

    let data = selectedProspectForEmailGroup?.map((i) => {
      return { prospect_id: i };
    });

    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.post(process.env.REACT_APP_USER_API_URL + "v1/campaign/groups/" + selectedEmailGroup + "/contacts", { data: data }, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setSnackbarOpen(true);
      setSnackbarMsg("Prospects added to email group successfully.");

      setLoading(false);

      setIsOpenEmailGroup(false);
      setSelectedProspectForEmailGroup([]);
      setSelectedEmailGroup(null);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const closeAddToEmailGroupSection = () => {
    setIsOpenEmailGroup(false);
    setSelectedProspectForEmailGroup([]);
    setSelectedEmailGroup(null);
  }

  const delCustomFilter = (filterval, filterType) => {
    let selected = allCustomFilterList?.filter(i => i?.value === filterval && i?.type === filterType);

    if (selected.length > 0) {
      if (filterType === 'credit') {
        if (selected[0]?.value === filterData?.credit) {
          setFilterData({ ...filterData, credit: 'all' });
          setCreditFilterOpen(false);
        }
      }
      if (filterType === 'salary') {
        if (selected[0]?.value === filterData?.income) {
          setFilterData({ ...filterData, income: 'all' });
          setSalaryFilterOpen(false);
        }
      }
      setAllCustomFilterList(prev => {
        return prev?.filter(i => i?.id !== selected[0]?.id);
      })
      axios.delete(process.env.REACT_APP_APPLICANT_API_URL + "v1/prospectfilter/" + selected[0]?.id).then(() => { }).catch((error) => { });
    }
  }

  return (<>
    {loading && <Loader />}
    <Helmet title="Prospects" />
    <div className={`${styles.pageTitleWrap}`}>
      <div className={`${styles.PageMainTTSec}`}>
        <PeoplePageTitle defaultPage={"Prospects"} />
        <Typography display="inline" className={`${styles.pageTitle} ${styles.Small}`} onClick={(e) => setAnchorEl(e.currentTarget)}>Prospects <ChevronDown /></Typography>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={(e) => setAnchorEl(null)}
          MenuListProps={{ "aria-labelledby": "basic-button" }}
        >
          <MenuItem className={`${styles.DropdownPageTitleMenu}`}>
            <Link to="/people/prospects">Prospect</Link>
          </MenuItem>
          <MenuItem className={`${styles.DropdownPageTitleMenu}`}>
            <Link to="/people/leaderboards">Leaderboard</Link>
          </MenuItem>
        </Menu>
        {totalCount > 0 && (<p className={`${styles.CountText}`}>({totalCount} Prospects)</p>)}
      </div>

      <nav aria-label="breadcrumb">
        <ol className={`${styles.breadcrumb}`}>
          <li className={`${styles.breadcrumbItem}`}><span><Home /></span>{" "}People</li>
          <li className={`${styles.breadcrumbItem} ${styles.active}`}>Prospects</li>
        </ol>
      </nav>
    </div>

    <div className={`${styles.BodyCon}`}>
      <div className={`${styles.mainCardDiv}`}>
        <div className={`${styles.mainCard}`}>
          {contentLoading && (<div className="Loader TableLoader">
            <TableLoader />
          </div>)}

          {!contentLoading && (<div className="control-pane">
            <div className={`${styles.Row}`}>
              <div className={`${styles.SearchFilterSec}`}>
                <div className={`${styles.SearchCon}`}>
                  <div className={`${styles.SearchConSec}`}>
                    <Search />
                    <input type="text" placeholder="Search" onChange={onChangeHandler.bind(this)} />
                  </div>
                  <div className={`${styles.ListGridBUCard}`}>
                    <div className={`${styles.ListGridBUSec}`}>
                      <div className={`${styles.ListGridBU} `} onClick={() => handleView("grid")}>
                        <List /> <span>List</span>
                      </div>
                      <div className={`${styles.ListGridBU} ${styles.Active}`}>
                        <Grid /> <span>Grid</span>
                      </div>
                    </div>
                  </div>
                  <Link className={`${styles.FilterBu}`} onClick={FilterOpenFunction}>
                    <Filter />
                  </Link>
                  {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("prospect:create") > -1 && (<button
                    className={`${styles.AddNoteBu}`} onClick={(e) => { setOpenAddProspectModal(true); setAddFormStep(1); }}>
                    <Plus /> <span>Prospect</span>
                  </button>)}
                </div>

                <div className={`${styles.FilterSec}`}>
                  <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
                    <p className={`${styles.FilterTitle}`}>
                      Filters
                      <span onClick={FilterCloseFunction}>
                        <ArrowRight />
                      </span>
                    </p>
                    <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width220} CusSelectFilter Filter CloseFilter`}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Property</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Property"
                          value={filterData.property || ""}
                          onChange={handleChangeFilter.bind(this, "property")}
                          endAdornment={filterData?.property && (<IconButton
                            size="small"
                            onClick={(e) => {
                              setFilterData((prev) => {
                                return { ...prev, property: "" };
                              });
                            }}
                          >
                            <X />
                          </IconButton>)}
                        >
                          {allProperties?.map((i) => {
                            return (<MenuItem value={i.value}>{i.label}</MenuItem>);
                          })}
                        </Select>
                      </FormControl>
                    </div>
                    <div className={`${styles.FilterCard} ${styles.Width220}`}>
                      <div className={`${styles.DashFilterSec} DashFilterSec Filter`}>
                        <DateRangePicker
                          format={"MM/dd/yy"}
                          placeholder={"Filter by date"}
                          placement={"bottomEnd"}
                          caretAs={Calendar}
                          showOneCalendar
                          value={filterData.created && Array.isArray(filterData.created) ? filterData.created : null}
                          onChange={changeDateFilter}
                        />
                      </div>
                    </div>
                    <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width220} CusSelectFilter Filter CloseFilter`}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Prospects</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Prospects"
                          value={filterData.prospect || []}
                          onChange={(e) => {
                            const value = e.target.value;

                            if (value.includes("all")) {
                              const isAllSelected = filterData.prospect.length === 7;
                              if (isAllSelected) {
                                setFilterData(prev => {
                                  return { ...prev, prospect: [] };
                                });
                              } else {
                                setFilterData(prev => {
                                  return { ...prev, prospect: ['applied', 'not_applied', 'screened', 'approved', 'declined', 'airbnb', 'archived'] };
                                });
                              }
                              return;
                            }

                            setFilterData(prev => {
                              return { ...prev, prospect: value };
                            });
                          }}
                          multiple
                          renderValue={(e) => {
                            if (e.length === 0)
                              return 'None Selected';
                            else if (e.length === 7)
                              return 'All selected';
                            else
                              return e.length + ' selected'
                          }}
                        >
                          <MenuItem value="all">
                            <Checkbox
                              indeterminate={!(filterData.prospect.indexOf("applied") > -1 && filterData.prospect.indexOf("not_applied") > -1 && filterData.prospect.indexOf("screened") > -1 && filterData.prospect.indexOf("approved") > -1 && filterData.prospect.indexOf("declined") > -1 && filterData.prospect.indexOf("airbnb") > -1 && filterData.prospect.indexOf("archived") > -1) && (filterData.prospect.indexOf("applied") > -1 || filterData.prospect.indexOf("not_applied") > -1 || filterData.prospect.indexOf("screened") > -1 || filterData.prospect.indexOf("approved") > -1 || filterData.prospect.indexOf("declined") > -1 || filterData.prospect.indexOf("airbnb") > -1 || filterData.prospect.indexOf("archived") > -1)}
                              checked={filterData.prospect.indexOf("applied") > -1 && filterData.prospect.indexOf("not_applied") > -1 && filterData.prospect.indexOf("screened") > -1 && filterData.prospect.indexOf("approved") > -1 && filterData.prospect.indexOf("declined") > -1 && filterData.prospect.indexOf("airbnb") > -1 && filterData.prospect.indexOf("archived") > -1}
                            />
                            All Prospects
                          </MenuItem>
                          <MenuItem value="applied">
                            <Checkbox checked={filterData.prospect.indexOf("applied") > -1} />
                            Applied
                          </MenuItem>
                          <MenuItem value="not_applied">
                            <Checkbox checked={filterData.prospect.indexOf("not_applied") > -1} />
                            Not Applied
                          </MenuItem>
                          <MenuItem value="screened">
                            <Checkbox checked={filterData.prospect.indexOf("screened") > -1} />
                            Screened
                          </MenuItem>
                          <MenuItem value="approved">
                            <Checkbox checked={filterData.prospect.indexOf("approved") > -1} />
                            Approved
                          </MenuItem>
                          <MenuItem value="declined">
                            <Checkbox checked={filterData.prospect.indexOf("declined") > -1} />
                            Declined
                          </MenuItem>
                          <MenuItem value="airbnb">
                            <Checkbox checked={filterData.prospect.indexOf("airbnb") > -1} />
                            Airbnb Guest
                          </MenuItem>
                          <MenuItem value="archived">
                            <Checkbox checked={filterData.prospect.indexOf("archived") > -1} />
                            Archived
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width180Fixed} CusSelectFilter Filter CloseFilter`}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Filter by Credit</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Filter by Credit"
                          value={filterData?.credit || ""}
                          onChange={(e) => { handleChangeFilter("credit", e); setCreditFilterDefaultOpen(true); }}
                          endAdornment={filterData?.credit && (<IconButton
                            size="small"
                            onClick={(e) => {
                              setFilterData((prev) => {
                                return { ...prev, credit: "" };
                              });
                            }}
                          >
                            <X />
                          </IconButton>)}
                          open={creditFilterOpen}
                          onClose={(e) => { setCreditFilterOpen(false); }}
                          onOpen={(e) => setCreditFilterOpen(true)}
                          renderValue={(selected) => {
                            if (!selected) return "";
                            if (selected === "all") return "All Credit Scores";
                            if (selected === "custom") return "Custom";
                            if (selected === "0,649") return "Below 650";
                            if (selected === "650,0") return "650 & Above";

                            const item = creditFilterList?.find(i => i.value === selected);
                            return item?.label || selected;
                          }}
                        >
                          <MenuItem value="all">All Credit Scores</MenuItem>
                          <MenuItem value={"0,649"}>Below 650</MenuItem>
                          <MenuItem value={"650,0"}>650 & Above</MenuItem>
                          {creditFilterList?.map(i => {
                            return <MenuItem value={i?.value} className={`${styles.CustomValue}`}>
                              {i?.label}
                              {i?.is_custom === 1 && <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  delCustomFilter(i?.value, 'credit');
                                }}
                              >
                                <X fontSize="small" />
                              </IconButton>}
                            </MenuItem>
                          })}
                          <MenuItem
                            value="custom"
                            className={`${styles.customcredit}`}
                            onClick={(e) => {
                              setAddCustomCredit(true);
                            }}
                          >
                            {"Custom"}
                          </MenuItem>
                          {addCustomCredit && (<div className={`${styles.CustomFilterSec}`}>
                            <form onSubmit={handleSubmit1(onSubmitCreditFiler)}>
                              <div className={`${styles.CustomFilterSecRow}`}>
                                <div className={`${styles.CustomFiletrField} FormGroup`}>
                                  <Controller
                                    name={`min`}
                                    control={control1}
                                    render={(field) => (<CreditScoreField
                                      {...field}
                                      id="outlined-basic"
                                      label="Min Score"
                                      variant="outlined"
                                      onClick={(e) => e.stopPropagation()}
                                      onKeyDown={(e) => e.stopPropagation()}
                                      onChange={(e) => {
                                        e.stopPropagation();
                                        field.onChange(e);
                                      }}
                                    />)}
                                  />
                                </div>
                                <div className={`${styles.CustomFiletrField} FormGroup`}>
                                  <Controller
                                    name={`max`}
                                    control={control1}
                                    render={(field) => (<CreditScoreField
                                      {...field}
                                      id="outlined-basic"
                                      label="Max Score"
                                      variant="outlined"
                                      onClick={(e) => e.stopPropagation()}
                                      onKeyDown={(e) => e.stopPropagation()}
                                      onChange={(e) => {
                                        e.stopPropagation();
                                        field.onChange(e);
                                      }}
                                    />)}
                                  />
                                </div>
                                <div className={`${styles.CustomFiletrBUsec}`}>
                                  <Button onClick={(e) => { setAddCustomCredit(false); setFilterData((prev) => { return { ...prev, credit: "" }; }); setCreditFilterOpen(false); }} className={`${styles.CancelPopupBU}`}>Cancel</Button>
                                  <Button className={`${styles.SubmitPopupBU}`} type="submit">Apply</Button>
                                </div>
                              </div>
                            </form>
                          </div>)}
                        </Select>
                      </FormControl>
                    </div>
                    <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width180} CusSelectFilter Filter CloseFilter`}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Filter by Salary</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Filter by Salary"
                          value={filterData?.income || ""}
                          onChange={(e) => {
                            handleChangeFilter("income", e);
                            setSalaryFilterDefaultOpen(true);
                          }}
                          endAdornment={filterData?.income && (<IconButton
                            size="small"
                            onClick={(e) => {
                              setFilterData((prev) => {
                                return { ...prev, income: "" };
                              });
                            }}
                          >
                            <X />
                          </IconButton>)}
                          open={salaryFilterOpen}
                          onClose={(e) => { setSalaryFilterOpen(false); }}
                          onOpen={(e) => setSalaryFilterOpen(true)}
                          renderValue={(selected) => {
                            if (!selected) return "";
                            if (selected === "all") return "All Salary";
                            if (selected === "custom") return "Custom";
                            if (selected === "0,20000") return "< $20,000";
                            if (selected === "20000,40000") return "$20,000 - $40,000";
                            if (selected === "40000,60000") return "$40,000 - $60,000";
                            if (selected === "60000,80000") return "$60,000 - $80,000";
                            if (selected === "80000,0") return "> $80,000";

                            const item = salaryFilterList?.find(i => i.value === selected);
                            return item?.label || selected;
                          }}
                        >
                          <MenuItem value="all">All Salary</MenuItem>
                          <MenuItem value="0,20000">&lt; $20,000</MenuItem>
                          <MenuItem value="20000,40000">$20,000 - $40,000</MenuItem>
                          <MenuItem value="40000,60000">$40,000 - $60,000</MenuItem>
                          <MenuItem value="60000,80000">$60,000 - $80,000</MenuItem>
                          <MenuItem value="80000,0">&gt; $80,000</MenuItem>
                          {salaryFilterList?.map(i => {
                            return <MenuItem value={i?.value} className={`${styles.CustomValue}`}>
                              {i?.label}
                              {i?.is_custom === 1 && <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  delCustomFilter(i?.value, 'salary');
                                }}
                              >
                                <X fontSize="small" />
                              </IconButton>}
                            </MenuItem>
                          })}
                          <MenuItem
                            value="custom"
                            className={`${styles.customcredit}`}
                            onClick={(e) => {
                              setAddCustomSalary(true);
                            }}
                          >
                            {"Custom"}
                          </MenuItem>
                          {addCustomSalary && (<div className={`${styles.CustomFilterSec}`}>
                            <form onSubmit={handleSubmit2(onSubmitSalaryFiler)}>
                              <div className={`${styles.CustomFilterSecRow}`}>
                                <div className={`${styles.CustomFiletrField} FormGroup`}>
                                  <Controller
                                    name={`min`}
                                    control={control2}
                                    render={(field) => (<MoneyField
                                      {...field}
                                      id="outlined-basic"
                                      label="Min Salary"
                                      variant="outlined"
                                      onClick={(e) => e.stopPropagation()}
                                      onKeyDown={(e) => e.stopPropagation()}
                                      onChange={(e) => {
                                        e.stopPropagation();
                                        field.onChange(e);
                                      }}
                                    />)}
                                  />
                                </div>
                                <div className={`${styles.CustomFiletrField} FormGroup`}>
                                  <Controller
                                    name={`max`}
                                    control={control2}
                                    render={(field) => (<MoneyField
                                      {...field}
                                      id="outlined-basic"
                                      label="Max Salary"
                                      variant="outlined"
                                      onClick={(e) => e.stopPropagation()}
                                      onKeyDown={(e) => e.stopPropagation()}
                                      onChange={(e) => {
                                        e.stopPropagation();
                                        field.onChange(e);
                                      }}
                                    />)}
                                  />
                                </div>
                                <div className={`${styles.CustomFiletrBUsec}`}>
                                  <Button onClick={(e) => { setAddCustomSalary(false); setFilterData((prev) => { return { ...prev, income: "" }; }); setSalaryFilterOpen(false); }} className={`${styles.CancelPopupBU}`}>Cancel</Button>
                                  <Button className={`${styles.SubmitPopupBU}`} type="submit">Apply</Button>
                                </div>
                              </div>
                            </form>
                          </div>)}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                  <div className={`${styles.ListGridBUCard}`}>
                    <div className={`${styles.ListGridBUSec}`}>
                      <div className={`${styles.ListGridBU} `} onClick={() => handleView("grid")}>
                        <List /> <span>List</span>
                      </div>
                      <div className={`${styles.ListGridBU} ${styles.Active}`}>
                        <Grid /> <span>Grid</span>
                      </div>
                    </div>
                  </div>
                  <Link className={`${styles.FilterBu}`} onClick={FilterOpenFunction}>
                    <Filter />
                  </Link>
                  {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("prospect:create") > -1 && (<button
                    className={`${styles.AddNoteBu}`} onClick={(e) => { setOpenAddProspectModal(true); setAddFormStep(1); }}>
                    <Plus /> <span>Prospect</span>
                  </button>)}
                </div>
              </div>
              {isOpenEmailGroup && (<AddToEmailGroup
                groupList={groupList}
                setSelectedEmailGroup={setSelectedEmailGroup}
                handleAddToGroup={handleAddToGroup}
                selectedProspectForEmailGroup={selectedProspectForEmailGroup}
                closeAddToEmailGroupSection={closeAddToEmailGroupSection}
              />)}
              <div className={`${styles.NotesRow}`}>
                {prospectFilteredList.map((item, index) => {
                  return (<ProspectCard
                    item={item}
                    isOpenEmailGroup={isOpenEmailGroup}
                    selectedProspectForEmailGroup={selectedProspectForEmailGroup}
                    handleProspectToggle={handleProspectToggle.bind(this)}
                    setOpenDeleteModal={setOpenDeleteModal.bind(this)}
                    setOpenLeaderBoardModal={setOpenLeaderBoardModal.bind(this)}
                    setArchiveModalOpen={setArchiveModalOpen.bind(this)}
                    setApplicationModalOpen={setApplicationModalOpen.bind(this)}
                    setDeleteId={setDeleteId.bind(this)}
                    setArchiveId={setArchiveId.bind(this)}
                    setIsArchived={setIsArchived.bind(this)}
                    setIsOpenEmailGroup={setIsOpenEmailGroup.bind(this)}
                    initiateVoiceCall={initiateVoiceCall.bind(this)}
                    openProspectConversation={openProspectConversation.bind(this)}
                  />);
                })}

                {prospectFilteredList.length > 0 && (<div className="Pagination TablePaginationNew List">
                  <TablePagination
                    count={totalCount}
                    color="primary"
                    page={filterData.page}
                    rowsPerPage={filterData.perPage}
                    onPageChange={(e, v) => {
                      setPage(v);
                      setFilterData((prev) => ({ ...prev, page: v }));
                    }}
                    rowsPerPageOptions={[
                      { label: "4", value: 4 },
                      { label: "8", value: 8 },
                      { label: "16", value: 16 },
                      { label: "All", value: -1 },
                    ]}
                    onRowsPerPageChange={(e) => {
                      setPage(0);
                      setPerPage(e.target.value);
                      setFilterData((prev) => ({
                        ...prev,
                        perPage: e.target.value,
                        page: 0,
                      }));
                    }}
                    labelRowsPerPage={"Prospects per Page:"}
                  />
                </div>)}

                {!contentLoading && prospectFilteredList?.length === 0 && (<div className={`${styles.NoDataMain}`}>
                  <div className={`${styles.NoDataIMG}`}>
                    <img src="/static/img/no-prospect.png" alt="No Data" />
                  </div>
                  <p className={`${styles.NoDataText}`}>Let's get started!</p>
                  <p className={`${styles.NoDataTextSub}`}>Prospect List is Currently Empty.</p>
                </div>)}
              </div>
            </div>
          </div>)}
        </div>
      </div>
    </div>

    <Dialog
      open={openDeleteModal}
      fullWidth
      maxWidth="sm"
      onClose={(e) => {
        setOpenDeleteModal(false);
        setDeleteId(0);
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">
        Are you sure you want to delete the Prospect Record?
        <button onClick={(e) => { setOpenDeleteModal(false); setDeleteId(0); }}>
          <X />
        </button>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div className="ModalFormGroup">
            <label className="PopupBodyText">The Prospect Record will be removed immediately.You can't undo this action.</label>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className="CancelPopupBU" onClick={(e) => { deleteConfirm(); }}>Delete</Button>
        <Button className="SubmitPopupBU" onClick={(e) => { setOpenDeleteModal(false); setDeleteId(0); }}>Cancel</Button>
      </DialogActions>
    </Dialog>

    <Dialog
      open={archiveModalOpen}
      fullWidth
      maxWidth="sm"
      onClose={(e) => setArchiveModalOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">
        Are you sure you want to {isArchived ? "unarchive" : "archive"} the Prospect Record?
        <button onClick={(e) => setArchiveModalOpen(false)}>
          <X />
        </button>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div className="ModalFormGroup">
            <label className="PopupBodyText">{isArchived ? "The Prospect Record will be unarchived immediately. You can archive it at any time." : "The Prospect Record will be archived immediately. You can unarchive it at any time."}</label>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className="CancelPopupBU" onClick={(e) => archiveConfirm()}>{isArchived ? "Unarchive" : "Archive"}</Button>
        <Button className="SubmitPopupBU" onClick={(e) => setArchiveModalOpen(false)}>Cancel</Button>
      </DialogActions>
    </Dialog>

    <Dialog
      open={openAddProspectModal}
      fullWidth
      maxWidth="sm"
      onClose={(e) => { setOpenAddProspectModal(false); }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp CustomWidthPopUs"
    >
      {addFormStep === 1 && (<StepOneForm
        setOpenAddProspectModal={setOpenAddProspectModal.bind(this)}
        onSave={onSubmitOne.bind(this)}
        selectedProperty={0}
      />)}
      {addFormStep === 2 && (<StepTwoForm
        setOpenAddProspectModal={setOpenAddProspectModal.bind(this)}
        onSave={onSubmitTwo.bind(this)}
        onSubmit={onAddProspectSubmit.bind(this)}
        isTourOption={true}
      />)}
      {addFormStep === 3 && (<StepThreeForm
        setOpenAddProspectModal={setOpenAddProspectModal.bind(this)}
        onSubmit={onAddProspectSubmit.bind(this)}
        prospect_name={stepOneData?.prospect_name}
        property_id={stepOneData?.property_id}
      />)}
    </Dialog>

    <Dialog
      open={applicationModalOpen}
      fullWidth
      maxWidth="sm"
      onClose={(e) => setApplicationModalOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">
        Are you sure you want to send application link?
        <button onClick={(e) => setApplicationModalOpen(false)}>
          <X />
        </button>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div className="ModalFormGroup">
            <label className="PopupBodyText">Send a application link via SMS. This link will allow to continue application.</label>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={(e) => sendApplicationLInk(e)} className="CancelPopupBU">Confirm</Button>
        <Button onClick={(e) => setApplicationModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
      </DialogActions>
    </Dialog>

    <Dialog
      open={openLeaderBoardModal}
      fullWidth
      maxWidth="sm"
      onClose={(e) => setOpenLeaderBoardModal(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">
        Are you sure you want to add to leader board?
        <button onClick={(e) => setOpenLeaderBoardModal(false)}>
          <X />
        </button>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div className="ModalFormGroup">
            <label className="PopupBodyText">The Prospect Record will be added to leader board immediately. You can remove from leader board it at any time.</label>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={(e) => setOpenLeaderBoardModal(false)} className="CancelPopupBU">Cancel</Button>
        <Button onClick={(e) => addToLeaderBoard(e)} className="SubmitPopupBU">Confirm</Button>
      </DialogActions>
    </Dialog>

    <Dialog
      open={openCallModal}
      fullWidth
      maxWidth="sm"
      onClose={(e) => setOpenCallModal(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">
        Prospect Call Confirmation
        <button onClick={(e) => setOpenCallModal(false)}>
          <X />
        </button>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div className="ModalFormGroup">
            <label className="PopupBodyText">Please confirm you wish to initiate a call to this prospect.</label>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={(e) => setOpenCallModal(false)} className="CancelPopupBU">Cancel</Button>
        <Button onClick={(e) => initiateVoiceCallConfirm()} className="SubmitPopupBU">Proceed</Button>
      </DialogActions>
    </Dialog>

    <Snackbar
      open={snackbarOpen}
      onClose={(e) => setSnackbarOpen(false)}
      TransitionComponent={Slide}
      message={snackbarMsg}
      autoHideDuration={10000}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      action={<IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={(e) => setSnackbarOpen(false)}
      >
        <X />
      </IconButton>}
    />

    <Footer />
  </>);
};

export default withCustomAuthenticationRequired(ProspectList, {
  onRedirecting: () => <Loader />,
});